import { VisionApplication } from '../application';
import { VisionWindowManager } from '../window/manager';
import { VisionWindow } from '../window/window';

class UserManager {
    private parent: VisionSecurityWindow;
    private permissionsGrid!: dhtmlXGridObject;

    constructor(parent: VisionSecurityWindow) {
        this.parent = parent;
        this.parent.roleAreas.addItem({
            id: 'user_definition',
            text: 'User Managment',
            icon: 'icons/information.png',
        });

        this.permissionsGrid = this.parent.roleAreas.cells('user_definition').attachGrid();
        this.permissionsGrid.setHeader(',Permission,Description', ',', ['text-align:center', 'text-align:center']);
        this.permissionsGrid.setColTypes('ch,ro,ro');
        this.permissionsGrid.init();

        this.permissionsGrid.addRow(1, ['0', 'Create New Users', 'Allows the creation of new user accounts.'], 1, '', '', false);
        this.permissionsGrid.addRow(2, ['0', 'Delete Users', 'Allows deleting existing user accounts.'], 2, '', '', false);
        this.permissionsGrid.addRow(3, ['0', 'Edit Users', 'Allows editing existing user accounts.'], 3, '', '', false);
        this.permissionsGrid.addRow(4, ['0', 'View Users', 'Allows viewing all user accounts.'], 4, '', '', false);
    }
}

class GroupManager {
    private layout!: dhtmlXLayoutObject;
    private parent: VisionSecurityWindow;
    private permissionsGrid!: dhtmlXGridObject;
    private resourceGrid!: dhtmlXGridObject;

    constructor(parent: VisionSecurityWindow) {
        this.parent = parent;
        this.parent.roleAreas.addItem({
            id: 'group_definition',
            text: 'Group Management',
            icon: 'icons/information.png',
        });

        this.layout = this.parent.roleAreas.cells('group_definition').attachLayout('2E');
        this.layout.cells('a').hideHeader();
        this.layout.cells('b').hideHeader();
        this.permissionsGrid = this.layout.cells('a').attachGrid();
        this.permissionsGrid.setHeader(',Permission,Description', ',', ['text-align:center', 'text-align:center']);
        this.permissionsGrid.setColTypes('ch,ro,ro');
        this.permissionsGrid.setInitWidths('50,*,*');
        this.permissionsGrid.setColAlign('center,left,left');
        this.permissionsGrid.init();

        this.permissionsGrid.addRow(1, ['0', 'Create New Groups', 'Allows the creation of new groups.'], 1, '', '', false);
        this.permissionsGrid.addRow(2, ['0', 'Delete Groups', 'Allows deleting existing groups.'], 2, '', '', false);
        this.permissionsGrid.addRow(3, ['0', 'Edit Groups', 'Allows editing existing groups.'], 3, '', '', false);
        this.permissionsGrid.addRow(4, ['0', 'View Groups', 'Allows viewing all groups.'], 4, '', '', false);

        this.resourceGrid = this.layout.cells('b').attachGrid();
        this.resourceGrid.setHeader(',Allow access to Group', ',', ['text-align:center', 'text-align:center']);
        this.resourceGrid.setColTypes('ch,ro');
        this.resourceGrid.setInitWidths('50,*');
        this.resourceGrid.setColAlign('center,left');
        this.resourceGrid.init();

        const folderRequest = VisionApplication.getInstance().assetFolderService.getFolders();
        folderRequest.then((data) => {
            if (data.parsedBody) {
                //console.log(data.parsedBody);
                for (let i = 0; i < data.parsedBody?.length; i++) {
                    this.resourceGrid.addRow(data.parsedBody[i].id, [0, data.parsedBody[i].name], 0, '', '', false);
                }
            }
        });
    }
}

export class VisionSecurityWindow extends VisionWindow {
    private layout!: dhtmlXLayoutObject;
    private rolesGrid!: dhtmlXGridObject;

    private userManager!: UserManager;
    private groupManager!: GroupManager;
    public roleAreas!: dhtmlXSideBar;

    constructor(windowManager: VisionWindowManager) {
        const height = window.innerHeight * 0.75;
        const width = window.innerWidth * 0.45;
        super(windowManager, {
            id: 'roles_window',
            title: 'Roles',
            x: 30,
            y: 30,
            width: width,
            height: height,
        });

        this.window.setText('Roles');

        this.buildUI();
    }

    private buildUI(): void {
        this.layout = this.window.attachLayout('2U');
        this.layout.cells('a').hideHeader();
        this.layout.cells('b').hideHeader();

        this.rolesGrid = this.layout.cells('a').attachGrid();
        this.rolesGrid.setHeader('Role,Description', ',', ['text-align:center', 'text-align:center']);
        this.rolesGrid.setColTypes('ro,ro');
        this.rolesGrid.init();

        this.roleAreas = this.layout.cells('b').attachSidebar();
        this.roleAreas.addItem({
            id: 'role_definition',
            text: 'Role Definition',
            icon: 'icons/information.png',
        });

        this.userManager = new UserManager(this);
        this.groupManager = new GroupManager(this);

        this.layout.cells('b').hideHeader();
    }
}
